import imageCompression from "browser-image-compression";

const form = {
    post: async function (url, formId, updateString, postDoneCallback) {
        // エラーメッセージをすべて排除
        $(".error__message").remove();
        $(".error").removeClass("error");

        const paramList = new FormData();
        const targetForm = $(formId);
        let imageFile = "";
        $(targetForm)
            .find('input, input[type="radio"]:checked, select, textarea')
            .map(function () {
                if ($(this).attr("type") === "file") {
                    if ($(this).prop("files").length >= 1) {
                        imageFile = $(this).prop("files")[0];
                    }
                } else {
                    const name = $(this).attr("name");

                    // チェックボックスだったら、チェックが入っているか確認
                    let targetValue = $(this).val();
                    if ($(this).attr("type") === "checkbox") {
                        if (!$(this).prop("checked")) {
                            targetValue = 9; //9は無効ConstUtil::MST_OFF
                        }
                    }
                    paramList.append(name, targetValue);
                }
            });

        $(targetForm)
            .find('input[type="radio"]:checked')
            .map(function () {
                const name = $(this).attr("name");
                paramList.append(name, $(this).val());
            });

        if (typeof postDoneCallback !== "function") {
            postDoneCallback = post.postDone;
        }

        // 画像の圧縮
        // NOTE: 複数の画像をアップロードする場合は枚数分の実行が必要
        await form.compressImage(paramList, imageFile);

        post.postAjaxData(url, paramList, updateString, postDoneCallback, form.postFail, null);
    },

    // POSTが完了した
    // 通常
    postDone: function (results) {
        form.activateButtons(".js-submit");
    },

    // 失敗。バリデーション失敗のときにも発生
    postFail: function (jqXHR) {
        // エラーの表示する。
        for (const key in jqXHR["responseJSON"]["errors"]) {
            const targetKey = key.replace(".", "");

            // 表示位置を取得する。
            if ($(".js-" + targetKey + "-error").length !== 0) {
                $(".js-" + targetKey + "-error").append(
                    '<span class="error__message">' + jqXHR["responseJSON"]["errors"][key] + "</span>"
                );
            } else {
                $(".js-" + targetKey).append(
                    '<span class="error__message">' + jqXHR["responseJSON"]["errors"][key] + "</span>"
                );
            }

            $(".js-" + targetKey).addClass("error");
        }

        form.activateButtons([".js-submit", ".js-update-button", ".js-upload-button"]);

        $("#js-nav-pagetop").trigger("click");
    },

    // 画像の圧縮
    compressImage: async function (paramList, imageFile) {
        if (imageFile !== "") {
            const options = {
                maxSizeMB: 5,
                maxWidthOrHeight: 1600
            };
            const compressedImageFile = await imageCompression(imageFile, options);
            paramList.append("imageFile", compressedImageFile);
        }
    },

    // ボタンを活性化
    activateButtons: function (buttonSelector) {
        const selectors = Array.isArray(buttonSelector) ? buttonSelector : [buttonSelector];
        selectors.forEach((selector) => {
            $(selector).prop("disabled", false);
        });
    },

    // ボタンを非活性化
    disableButtons: function (buttonSelector) {
        const selectors = Array.isArray(buttonSelector) ? buttonSelector : [buttonSelector];
        selectors.forEach((selector) => {
            $(selector).prop("disabled", true);
        });
    }
};

window.form = form;
